


















import { defineComponent, PropType } from '@vue/composition-api';
import cDrawerContent                from '@/components/drawer/drawer-content/drawer-content.component.vue';
import cButton                       from '@/components/form/button/button.component.vue';
import { DrawerPanelProps }           from '@/components/drawer/drawer.types';

export default defineComponent({
  name: 'cDrawerPanel',
  components: {
    cDrawerContent,
    cButton,
  },
  props: {
    drawerPanelProps: {
      type: Object as PropType<DrawerPanelProps>,
      required: true,
    },
    showBottomButton: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const onClick = (event: MouseEvent): void => {
      context.emit('onClick', event);
    };

    return {
      onClick,
    };
  },
});
